<template>
  <!-- 时间线组件 -->
  <div class="time-line">
    <div class="section" :style="'padding-left:'+ timeLines.time_width + 'px'">
      <ul>
        <li v-for="(item, index) in course" :key="index" style="list-style: none;">
          <div class="timeWeek" v-if="index-1>=0?(item.createDate).substring(0,10)!==(course[index-1].createDate).substring(0,10) && timeLines.time_type=='log':true && timeLines.time_type=='log'" :style="index==0?'border:none':''">
            {{item.createDate.substring(0,10)}}
            <span style="margin-left:24px">
              {{week[new Date(item.createDate).getDay()]}}
            </span>
            <div class="line" style="top:95px;height:calc(100% - 90px)" v-if="index<=course.length-2&&(item.createDate).substring(0,10)===(course[index+1].createDate).substring(0,10)?true:false" />
          </div>
          <!-- 线 -->
          <div v-else-if="timeLines.time_type=='log'" class="line" v-show="index<=course.length-2&&(item.createDate).substring(0,10)===(course[index+1].createDate).substring(0,10)" />
          <div v-else class="line" v-show="index!=course.length-1" />
          <!-- 卡片 -->
          <div class="item-wrapper" v-if="timeLines.time_type=='card'">
            <div v-show="index != 0" class="circle" />
            <div v-show="index === 0" class="circles">
              <div class="circle1" />
            </div>
            <div class="title_time">
              <h6 class="title" style="color:#2878ff">{{item.releaseNumber}}</h6>
              <h6 class="time">{{(item.updateDate).substring(0,10)}}</h6>
            </div>
            <div class="item-content">
              <div class="desc_title">{{item.title}}</div>
              <div style="white-space: pre-wrap;">
                <div class="desc" v-if="item.content" v-html="item.content.replace(/\\n/g, '<br/>')">{{item.content}}</div>
              </div>
            </div>
          </div>
          <!-- 普通 -->
          <div v-else>
            <div v-if="timeLines.time_type=='log'">
              <div class="tab-wrapper">
                <div v-show="index != 0" class="circle" />
                <div v-show="index === 0" class="circles" />
                <div class="title_time">
                  <div>
                    <h6 class="time">{{item.createDate.substring(10,16)}}</h6>
                  </div>
                </div>
                <div class="item-content">
                  <img v-if="item.operator.avatar!=''" class="info_personnel_surname" :src="item.operator.avatar">
                  <div v-else class="info_personnel_surname">{{(item.operator.name).substring(0,1)}}</div>
                  <div style="width:calc(100% - 36px)">
                    <div class="content_names">
                      <span v-if="channel === 'wechat'"><ww-open-data type="userName" :openid="item.operator.name" /></span>
                      <span v-else>{{item.operator.name}}</span>
                      <div class="content_desc">{{item.title}}</div>
                    </div>
                    <div class="content_desc">{{item.content}}</div>
                    <div class="file_list">
                      <div v-for="(file,index1) in item.files" :key="index1" @click="previewFile(item, index1)">
                        <div v-if="file.screenshot === '1'">
                          <img :src="file.absoUrl" alt="" style="max-width: 200px;max-height: 100px;">
                        </div>
                      </div>
                      <div v-for="(file,index1) in item.files" :key="index1" @click="previewFile(item, index1)">
                        <div v-if="file.screenshot !== '1'">
                          <i class="iconfont icon-wenjian file__icon" />
                          <span>{{file.fileName}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-else class="tab-wrapper">
              <div v-show="index != 0" class="circle" />
              <div v-show="index === 0" class="circles" />
              <div class="title_time">
                <div>
                  <h6 class="time" v-show="index-1>=0?(item.createDate).substring(0,10)!==(course[index-1].createDate).substring(0,10):true">{{(item.createDate).substring(0,10)}}</h6>
                  <h4 class="time">{{(item.createDate).substring(10,16)}}</h4>
                </div>
              </div>
              <div class="item-content">
                <img v-if="item.createUser.avatar!=''" class="info_personnel_surname" :src="item.createUser.avatar">
                <div v-else class="info_personnel_surname">{{(item.createUser.name).substring(0,1)}}</div>
                <div style="width:calc(100% - 36px)">
                  <div class="content_names">
                    <span v-if="channel === 'wechat'"><ww-open-data type="userName" :openid="item.createUser.name" /></span>
                    <span v-else>{{item.createUser.name}}</span>
                    <div class="content_desc">{{item.title}}</div>
                  </div>
                  <div class="content_desc" v-if="item.content" v-html="item.content.replace(/\n/g, '<br/>')">{{item.content}}</div>
                  <div class="file_list">
                    <div v-for="(file,index1) in item.files" :key="index1" @click="previewFile(item, index1)">
                      <div v-if="file.screenshot === '1'">
                        <img :src="file.absoUrl" alt="" style="max-width: 200px;max-height: 100px;">
                      </div>
                    </div>
                    <div v-for="(file,index1) in item.files" :key="index1" @click="previewFile(item, index1)">
                      <div v-if="file.screenshot !== '1'">
                        <i class="iconfont icon-wenjian file__icon" />
                        <span>{{file.fileName}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 视频预览组件 -->
    <VideoPreview
      :visible.sync="showVideo"
      :url="videoUrl"
      @update:visible="val => console.log('visible 更新为:', val)"
    />
  </div>
</template>

<script>
import { initPreviewAuth, getShowAuthority } from '../../utils/api/file'
import preview from 'dingtalk-jsapi/api/biz/cspace/preview' // 预览文件
import { wpsOfficeConfig } from '../../utils/wpsoffice/wpsOffice'
import VideoPreview from './videoPreview/index.vue'
export default {
  name: 'TimeLine',
  components: {
    VideoPreview
  },
  props: {
    timeLines: { // 页面展示数据
      type: Object,
      default: () => ({})
    },
    courses: { // 页面展示数据
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      course: [],
      fileIds: '',
      spaceId: '',
      fileId: '',
      fileName: '',
      fileSize: '',
      fileType: '',
      fileIdAuthority: '',
      nodeId: '',
      week: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      showVideo: false,
      videoUrl: ''
    }
  },
  watch: {
    courses: {
      handler(value) {
        this.course = this.courses
      }
    }
  },
  created() {

  },
  mounted() {
    this.course = this.courses
  },
  methods: {
    previewFile(item, index) {
      // var filesDing = item.files
      // var index2 = ''
      this.fileIds = item.files[index].dingFileId
      this.spaceId = item.files[index].dingSpaceId
      this.fileId = item.files[index].dingFileId
      this.fileName = item.files[index].fileName
      this.fileSize = item.files[index].fileSize
      this.fileType = item.files[index].fileFormat
      this.fileIdAuthority = item.files[index].id
      if (item.files[index].objectType === '2') {
        this.nodeId = item.files[index].objectId
      } else {
        this.nodeId = ''
      }
      var date1 = {
        id: this.nodeId,
        fileId: this.fileIdAuthority
      }
      getShowAuthority(date1).then((data1) => {
        if (data1.code === 10000) {
          var date = {
            fileIds: this.fileIds
          }
          if (item.files[index]?.source === 'ding') {
            initPreviewAuth(date).then((data) => {
              if (data.code === 10000) {
                preview({
                  corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
                  spaceId: this.spaceId,
                  fileId: this.fileId,
                  fileName: this.fileName,
                  fileSize: this.fileSize,
                  fileType: this.fileFormat,
                  onSuccess: function(res) {
                    console.log(res, '')
                  },
                  onFail: function(err) {
                    console.log(err)
                  // alert('数据 ' + JSON.stringify(err))
                  }
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          } else {
            var imgs = ['MP4', 'AVI', 'WMV', 'MKV', 'FLV', 'MPG', 'MPEG', 'M2V', 'M3U8', 'TS', 'MOV', 'WMV', 'RM', 'RMVB', 'ASF', 'VOB', 'DAT', 'DV', 'M4V', 'WEBM', 'OGG', '3GP', 'MPEG4',
              'mp4', 'avi', 'wmv', 'mkv', 'flv', 'mpg', 'mpeg', 'm2v', 'm3u8', 'ts', 'mov', 'wmv', 'rm', 'rmvb', 'asf', 'vob', 'dat', 'dv', 'm4v', 'webm', 'ogg', '3gp', 'mpeg'
            ]
            if (imgs.includes(item.files[index].fileFormat)) {
              this.showVideo = true
              this.videoUrl = item.files[index].absoUrl
            } else {
              wpsOfficeConfig(item.files[index])
            }
          }
        } else {
          this.$message.warning(data1.info)
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.section {
  max-width: 100%;
  li {
    box-sizing: border-box;
    position: relative;
    padding-bottom: 20px;
    .timeWeek{
      width: calc(100% + 140px);
      margin: 35px 0 35px -147px;
      padding-top: 28px;
      font-size: $font_18;
      font-family: $font_family1;
      color: $color_1;
      font-weight: 500;
      line-height: 25px;
      display: flex;
      align-items: center;
      border-top: 1px solid #E9E9EA;
    }
    .line {
      position: absolute;
      top: 6px;
      left: 0;
      height: 100%;
      border-left: 1px solid #e9e9ea;
    }
    .tab-wrapper {
      position: relative;
      .circle {
        width: 11px;
        height: 11px;
        background: $color_white;
        border: 1px solid #E9E9EA;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: -6px;
      }
      .circles {
        width: 11px;
        height: 11px;
        background: $color_main;
        border: 1px solid $color_main;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: -6px;
      }
      .across-line {
        width: 18.5%;
        height: 1px;
        background: #e9e9ea;
        position: absolute;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
      }
      .item-content {
        margin: 0 0 0 26px;
        box-sizing: border-box;
        background: $color_white;
        display: flex;
        align-items: flex-start;
        .content_names {
          display: flex;
          align-items: center;
          font-size: $font_16;
          font-family: $font_family1;
          font-weight: 400;
          color: $color_1;
          line-height: 22px;
          .content_desc {
          font-size: $font_14;
          font-family: $font_family1;
          font-weight: 400;
          color: $color_9;
          line-height: 20px;
          margin: 0px 10px;
          overflow-wrap: break-word;
        }
        }
        .content_desc {
          font-size: $font_14;
          font-family: $font_family1;
          font-weight: 400;
          color: $color_9;
          line-height: 20px;
          margin-top: 11px;
          overflow-wrap: break-word;
        }
      }
      .title_time {
        margin: 0 30px;
        position: absolute;
        left: -190px;
        text-align: right;
      }
      .time {
        font-size: $font_14;
        font-family: $font_family;
        font-weight: 400;
        color: $color_9;
        line-height: 20px;
        width: 137px;
      }
    }
    .item-wrapper {
      position: relative;
      padding-bottom: 20px;
      .circle {
        width: 16px;
        height: 16px;
        background: #f5f5f5;
        border: 1px solid #e9e9ea;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: -8.5px;
      }
      .circles {
        width: 21px;
        height: 21px;
        position: absolute;
        top: 5px;
        left: -11px;
        display: inline-block;
        border: 1px solid $color_main;
        border-radius: 50%;
        background: $color_white;
      }
      .circle1 {
        width: 13px;
        height: 13px;
        background: $color_main;
        border-radius: 50%;
        margin: 4px;
      }
      .across-line {
        width: 18.5%;
        height: 1px;
        background: #e9e9ea;
        position: absolute;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
      }
      .item-content {
        margin: 0 47px;
        box-sizing: border-box;
        background: $color_white;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 19px 52px;
        display: inline-block;
        .desc_title {
          font-size: $font_18;
          font-family: $font_family1;
          font-weight: 500;
          color: $color_1;
          line-height: 28px;
          margin: 0 10px 11px 0px;
        }
        .desc {
          font-size: $font_14;
          font-family: $font_family1;
          font-weight: 400;
          color: $color_8;
          line-height: 30px;
          // margin: 8px 10px;
        }
      }
      .title_time {
        width: 300px;
        margin: 0 33px;
        position: absolute;
        left: -367px;
        text-align: right;
      }
      .title {
        font-size: $font_18;
        font-family: $font_family1;
        font-weight: 600;
        color: $color_1;
        line-height: 28px;
      }
      .time {
        font-size: $font_14;
        font-family: $font_family1;
        font-weight: 400;
        color: $color_9;
        line-height: 20px;
        margin: 9px 0;
      }
    }
  }
}
.info_personnel_surname {
  width: 24px;
  height: 24px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_white;
  line-height: 25px;
  text-align: center;
  color: $color_white;
  background: $color_main;
  border-radius: 50%;
  margin-right: 12px;
}
.file_list {
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: $color_9;
  padding: 2px 0;
  line-height: 22px;
  margin: 0;
}
.file__icon {
  font-size: $font_14;
  color: #ffb83e;
  margin-right: 5px;
}

</style>
